<template>
  <div id="m">
    <Header></Header>
    <router-view />
  </div>
</template>

<script>
import Header from 'components/header.vue'

export default {
  name: 'home',
  components: {
    Header
  }
}
</script>

<style lang="scss" scoped>
@import "./assets/styles/base.css";
</style>
